// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { NgxsLoggerPluginModule } from '@ngxs/logger-plugin';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js/plugins/zone-error';
import { Environment } from '@technocom/core';

export const environment: Environment = {
  production: false,
  name: 'dev',
  api: {
    root: '/migrants',
    withCredentials: true,
  },
  web: {
    security: {
      sessionEndpoint: '/authentification/current-user',
    },
  },
  options: {
    plugins: [NgxsLoggerPluginModule.forRoot(), NgxsReduxDevtoolsPluginModule.forRoot()], // ngxs plugins
    publicPath: 'public',
    securePath: 'operation',
  },
};
